import { defineNuxtRouteMiddleware } from '#imports'
import { asRouteMiddleware, logOut } from '@utils/route-guards'

export default defineNuxtRouteMiddleware(asRouteMiddleware(logOut))
